export default __webpack_public_path__ + "static/media/robot-icon-white.34b3a326.png";